import { Component, OnDestroy, OnInit, signal } from '@angular/core';
import { IContractClaimStatusSummary, IContractClaimTypeSummary, IUpdatedContractsMultipleStatuses } from '../models';
import { MatDialogRef } from '@angular/material/dialog';
import { Subscription, finalize } from 'rxjs';
import { SettingsService } from 'src/app/services/settings.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ContractsService } from '../contracts.service';
import { KEYS, MessageToUiService } from 'src/app/services/message-to-ui.service';
import { GlobalSpinnerService } from 'src/app/shared/global-spinner/global-spinner.service';
import { CommonModule, KeyValue } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MessageModule } from 'primeng/message';
import { SelectModule } from 'primeng/select';

@Component({
  selector: 'app-change-status',
  templateUrl: './change-status.component.html',
  styleUrls: ['./change-status.component.scss'],
  imports: [CommonModule, TranslateModule, FormsModule, SelectModule, MessageModule]
})
export class ChangeStatusComponent implements OnInit, OnDestroy {

  private _selectedIds: number[];
  public get selectedIds() {
    return this._selectedIds;
  }
  public set selectedIds(value: number[]) {
    this._selectedIds = value;
    this.getWarningMessage();
  }
  selectedClaimTypeCodes: string[];

  selectedClaimTypes: IContractClaimTypeSummary[];
  messages: string[];
  isEnglish: boolean;
  isAnyContractWarned = signal(false);
  updateStatusOnAllCasesIsActive = signal(false);

  subscriptions: Subscription[] = [];
  contractsStatusInfo: IUpdatedContractsMultipleStatuses[];

  selectedClosingFee: KeyValue<number, boolean>;

  constructor(private dialogRef: MatDialogRef<any>,
    private settingsService: SettingsService,
    private translate: TranslateService,
    private service: ContractsService,
    private messageToUi: MessageToUiService,
    private spinner: GlobalSpinnerService) {
  }

  ngOnDestroy(): void {
    this.subscriptions?.forEach(x => x.unsubscribe());
  }

  ngOnInit(): void {
  }

  getWarningMessage() {
    this.subscriptions.push(this.settingsService.getSettingValueByName('MaxNumberOfChangedContracts').subscribe(_ => {
      const max = +_;
      if (this.selectedIds.length > max) {
        this.messages = [this.translate.instant('Contracts.ChangeContract_WarningMessage', { noOfContracts: this.selectedIds.length })];
      }
      else {this.messages = []; }
    }));
  }

  getClassForWorkListItem(item: IContractClaimStatusSummary): string {
    if (item.workList === true) {return 'work-list'; }
    return '';
  }

  cancel() {
    this.dialogRef.close(false);
  }

  update() {
    this.spinner.show();

    this.contractsStatusInfo.forEach(x => {
      this.setNewStatus(x);
    });

    this.service.changeStatus(this.contractsStatusInfo, this.selectedClosingFee?.value ?? false)
      .pipe(finalize(() => { this.spinner.hide(); }))
      .subscribe({
        next: (_) => { this.dialogRef.close(true); },
        error: () => { this.messageToUi.errorKey(KEYS.Error_GenericMessage); }
      });
  }

  setNewStatus(statusInfo: IUpdatedContractsMultipleStatuses) {
    const newStatus = this.selectedClaimTypes.find((c => c.claimTypeCode == statusInfo.claimTypeCode));
    if (newStatus) {
      statusInfo.newStatusId = newStatus?.selectedStatus.id;
    }
  }

  onSelectStatus(event, claimType: IContractClaimTypeSummary) {
    this.updateStatusOnAllCasesIsActive.set(event.value?.updateStatusOnAllCases);
    if (event.value?.initiateClosingFee == true) {
      this.subscriptions.push(this.service.getClosingFees(event.value.id, this.selectedIds).subscribe(closingFees => {
        claimType.closingFeeText = "";
        const differentCustomers = [...new Set(closingFees.map(x => x.parentCustomerNumber))].length > 1;
        closingFees.forEach(x => {
          if (x && x.fee && x.fee > 0) {
            if (!x.secondaryFee || differentCustomers)
              {claimType.closingFeeText += ` ${this.translate.instant('Contracts.ChangeStatus_ClosingFee', { fee: x.fee, parent: x.parentCustomerNumber })} `; }
            else {
              claimType.closingFees = [
                { key: x.fee, value: false } as KeyValue<number, boolean>,
                { key: x.secondaryFee, value: true } as KeyValue<number, boolean>
              ];
              this.selectedClosingFee = claimType.closingFees[0];
            }
          }
        });
      }));
    }
  }
}
